import { useMatches } from '@tanstack/react-router'
import { useEffect } from 'react'

export default function useScrollToTop() {
  const matches = useMatches()
  const fullPath = matches.slice(-1)[0].routeId

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    })
  }, [fullPath])

  return null
}
